import { FileText, FileSpreadsheet, FileImage, File } from 'lucide-react';

const EXTENSION_MAP = {
  // PDF
  pdf: { icon: FileText, color: 'text-red-500', bg: 'bg-red-50', label: 'PDF' },
  // Word
  doc: { icon: FileText, color: 'text-blue-600', bg: 'bg-blue-50', label: 'DOC' },
  docx: { icon: FileText, color: 'text-blue-600', bg: 'bg-blue-50', label: 'DOCX' },
  // Excel
  xls: { icon: FileSpreadsheet, color: 'text-green-600', bg: 'bg-green-50', label: 'XLS' },
  xlsx: { icon: FileSpreadsheet, color: 'text-green-600', bg: 'bg-green-50', label: 'XLSX' },
  csv: { icon: FileSpreadsheet, color: 'text-green-600', bg: 'bg-green-50', label: 'CSV' },
  // Images
  png: { icon: FileImage, color: 'text-purple-500', bg: 'bg-purple-50', label: 'PNG' },
  jpg: { icon: FileImage, color: 'text-purple-500', bg: 'bg-purple-50', label: 'JPG' },
  jpeg: { icon: FileImage, color: 'text-purple-500', bg: 'bg-purple-50', label: 'JPEG' },
  gif: { icon: FileImage, color: 'text-purple-500', bg: 'bg-purple-50', label: 'GIF' },
  webp: { icon: FileImage, color: 'text-purple-500', bg: 'bg-purple-50', label: 'WEBP' },
  svg: { icon: FileImage, color: 'text-purple-500', bg: 'bg-purple-50', label: 'SVG' },
};

const DEFAULT_TYPE = { icon: File, color: 'text-slate-500', bg: 'bg-slate-50', label: 'FILE' };

export function getFileTypeInfo(filename) {
  if (!filename) return DEFAULT_TYPE;
  const ext = filename.rsplit ? filename.split('.').pop().toLowerCase() : filename.split('.').pop()?.toLowerCase();
  return EXTENSION_MAP[ext] || DEFAULT_TYPE;
}

export function formatFileSize(bytes) {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
